import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, TextField, Button, Typography, Alert, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff, LocalShipping } from "@mui/icons-material";
import { useAuth } from "../context/AuthContext";
import { BRAND_COLOR } from "../theme";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        px: 3,
        background: `linear-gradient(180deg, ${BRAND_COLOR} 0%, ${BRAND_COLOR} 220px, #faf7f5 220px)`,
      }}
    >
      <Box sx={{ textAlign: "center", color: "#fff", mb: 4 }}>
        <LocalShipping sx={{ fontSize: 44 }} />
        <Typography variant="h5" fontWeight={700} mt={1}>
          denzo Driver
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.85 }}>
          Sign in with your driver account
        </Typography>
      </Box>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ bgcolor: "#fff", borderRadius: 3, p: 3, boxShadow: "0 8px 24px rgba(0,0,0,0.08)" }}
      >
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          label="Username"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          required
        />
        <TextField
          label="Password"
          type={showPassword ? "text" : "password"}
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((s) => !s)} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button type="submit" fullWidth variant="contained" size="large" disabled={loading} sx={{ mt: 3, py: 1.3 }}>
          {loading ? "Signing in..." : "Sign In"}
        </Button>
      </Box>
    </Box>
  );
}
